<article class="person-card" tabindex="-1" [attr.aria-labelledby]="headingId">
  <h3 class="sr-only" [id]="headingId">User: {{ person.name }}</h3>
  <a class="person-card__link" uiSref="profile.about" [uiParams]="{ profileId: person.slug }">
    <ut-avatar-badges class="person-card__avatar" [user]="person" aria-hidden="true"></ut-avatar-badges>
    <span class="person-card__text">
      <span class="person-card__name">{{ person.name }}</span>
      @if (isYou) {
        <span class="person-card__sub">You</span>
      } @else if (subtitle) {
        <span class="person-card__sub" [innerHTML]="subtitleHtml"></span>
      }
      <span class="person-card__meta">User</span>
    </span>
  </a>
  @if (canFollow) {
    <ut-community-follow-btn [user]="person" design="2026" size="sm"></ut-community-follow-btn>
  }
</article>
